app.factory('forecastService', [
  '$http',
  '$location',
  'Lightbox',
  function($http, $location, Lightbox) {
    var item
    var view

    return {
      getForecastByDC: () => {
        return $http
          .get('/api/forecasts/dc')
          .then(res => res.data)
          .then(setItemFlag)
          .catch(errorHandler)
      },

      getDCs: () => {
        return $http
          .get('/api/dcs')
          .then(res => res.data)
          .catch(errorHandler)
      },

      getView: function() {
        if (view) return view //"cache"

        return $http
          .get('/api/forecasts/view')
          .then(res => {
            view = res.data

            return res.data
          }, errorHandler)
          .then(setItemClass)
          .then(setItemFlag)
      },
      viewItem: function(i) {
        item = i

        console.log(item);
        
        $location.path('/forecast/' + item.id)
      },
      getItem: function(id) {
        if (view)
          return _.find(view, i => {
            return i.id == id
          })

        if (!view) {
          return this.getView().then(res => {
            let items = res
            let itemFound = _.find(items, i => {
              return i.id == id
            })
            if (!itemFound) {
              alert.error('Item not found')
            } else {
              return itemFound
            }
          })
        }
      },
      getItemData: function(item) {
        if (
          item['atendido_lb'] === 0 && 
          item['atendido_h'] === 0 && 
          item['atendido_s'] === 0) {
            return { bundles: [] }
          }

        let material_id = item['material_id']

        alert.info("<i class='fa fa-refresh fa-spin fa-fw'></i> Searching bundles...", 'Info', {
          timeOut: 0,
          extendedTimeOut: 0,
        })

        return $http
          .get('/api/forecasts/view/' + material_id)
          .then(res => res.data)
          .then(itemData => {
            alert.clearAll()
            alert.success('Bundles loaded!')
            return itemData
          })
      },
      createDoughnutChart: function(item) {
        let inspected = _.max([item.atendido_lb + item.atendido_h, 0])
        let balance = _.max([item.balance_lb + item.balance_h, 0])

        let labels = ['Inspected', 'Balance']
        let colors = ['#00A65A', '#dcdcdc']
        return {
          labels: labels,
          data: [inspected, balance],
          colors: colors,
        }
      },
      createSupplierChart: function(itemData) {
        let suppliers = itemData.suppliers
        let chart = {}
        chart.suppliers = []
        chart.totals = []

        _.forEach(suppliers, s => {
          chart.suppliers.push(s['fornecedor_nome'])
          chart.totals.push(s['total'])
        })

        chart.colors = ['#00a7d0', '#00c0ef', '#5ad6f8']

        return chart
      },
      openImage: function(bundles, index) {
        let images = []

        _.forEach(bundles, b => {
          let caption = "<div class='row'>"
          caption += "     <div class='col-lg-5 col-xs-5'>"
          caption +=
            "        <span class='pull-left'>" + (b['serial'] == null ? '' : b.serial) + '</span>'
          caption += '    </div>'
          caption += "     <div class='col-lg-2 col-xs-2'>"
          caption +=
            "        <span class='text-center'>" + _.toString(b['medida_cavalete']) + '</span>'
          caption += '    </div>'
          caption += "     <div class='col-lg-5 col-xs-5'>"
          caption += "        <span class='pull-right'>" + b['grade'] + '</span>'
          caption += '    </div>'
          caption += '</div>'

          let url = b['url']
          images.push({ caption, url })
        })
        Lightbox.openModal(images, index)
      },
    }
  },
])

function setItemClass(items) {
  _.forEach(items, item => {
    item.classLb = ''
    item.classH = ''
    let veryHighNumber = 100000

    if (item['pedido_lb'] !== 0) {
      if (_.inRange(item['percentual_lb'], 70, veryHighNumber)) item.classLb = 'bg-green disabled'
      if (_.inRange(item['percentual_lb'], 0, 40)) item.classLb = 'bg-red disabled'
      if (_.inRange(item['percentual_lb'], 40, 70)) item.classLb = 'bg-yellow disabled'
    }

    if (item['pedido_h'] !== 0) {
      if (_.inRange(item['percentual_h'], 70, veryHighNumber)) item.classH = 'bg-green disabled'
      if (_.inRange(item['percentual_h'], 0, 40)) item.classH = 'bg-red disabled'
      if (_.inRange(item['percentual_h'], 40, 70)) item.classH = 'bg-yellow disabled'
    }
  })
  return items
}

// TODO: make this dynamic
function setItemFlag(items) {
  _.forEach(items, item => {
    item.flagSrc = ''

    // if(item["empresa_id"] === 1) item.flagSrc = "https://s3-us-west-2.amazonaws.com/stonehenge-assets/flags/china.svg";
    // if(item["empresa_id"] === 2) item.flagSrc = "https://s3-us-west-2.amazonaws.com/stonehenge-assets/flags/china.svg";
    // if(item["empresa_id"] === 5) item.flagSrc = "https://s3-us-west-2.amazonaws.com/stonehenge-assets/flags/china.svg";

    if (item.id_empresa === 1) {
      item.flagSrc = 'assets/flags/brazil.svg'
      item.country = 'brazil'
    }
    if (item.id_empresa === 2) {
      item.flagSrc = 'assets/flags/india.svg'
      item.country = 'india'
    }
    if (item.id_empresa === 5) {
      item.flagSrc = 'assets/flags/china.svg'
      item.country = 'china'
    }
  })
  return items
}
